import { usePunditUserContext } from "@/react/contexts/punditUserContext";

export const useCircuitBreaker = (feature: string): boolean => {
  const { circuitBreakers } = usePunditUserContext();

  return Boolean(circuitBreakers?.[feature]);
};
